<header id="landing_info" class="image_background">
  <div class="header_container">
    <h1 i18n>Una <span style="font-family: var(--saol-italic);">revolución</span> de la salud.</h1>
    <p class="" i18n>Te invitamos a ser parte de Bhavani y cambiar tu forma de vivir. En los últimos 6 años hemos
      apoyado y acompañado a más de 6,000 personas a superar distintos obstáculos, a mejorar su salud, a reconectarse
      con la vida y vivir más plenamente.</p>
    <a class="button mt-5"
      [href]="this.platformBaseUrl+'registro/?r='+this.referalCode+ (this.iparam ? '&i='+this.iparam:'')" i18n>Crear
      cuenta</a>
  </div>
</header>
<section id="general_info">
  <div class="container general_info_container">
    <img src="assets/imgs/svgs/fungi_group.svg" alt="Icono grupo de hongos" i18n-alt>

    <h2 class="banner_title " style="margin-top: 2rem;" i18n>¿Para quién es el tratamiento de microdosis hongos?</h2>
    <p class="subtitle text" style="margin-top: 2rem;" i18n>Al ser una regeneración neuronal y regulación de
      neurotransmisores, beneficia a cualquier persona pues optimiza el funcionamiento de nuestro cerebro y de nuestra
      percepción.
    </p>
  </div>
</section>
<section id="benefits">
  <component-splited-header [h2Content]="benefits_header" [paragraphTemplate]="beneftis_paragraph">
  </component-splited-header>
  <div class="svgs_container">
    <div class="svgs_card">
      <img src="assets/imgs/svgs/stress.svg" alt="Icono de estrés" i18n-alt srcset="">
      <p class="subtitle" i18n>Manejo de estrés</p>
    </div>
    <div class="svgs_card">
      <img src="assets/imgs/svgs/depression.svg" alt="Icono depresión" i18n-alt srcset="">
      <p class="subtitle" i18n>Antidepresivo y ansiolítico</p>
    </div>
    <div class="svgs_card">
      <img src="assets/imgs/svgs/creativity.svg" alt="Icono creatividad" i18n-alt srcset="">
      <p class="subtitle" i18n>Aumenta la creatividad</p>
    </div>
    <div class="svgs_card">
      <img src="assets/imgs/svgs/ego.svg" alt="Icono ego" i18n-alt srcset="">
      <p class="subtitle" i18n>Desolidifica el ego</p>
    </div>
    <div class="svgs_card">
      <img src="assets/imgs/svgs/empathy.svg" alt="Icono empatia" i18n-alt srcset="">
      <p class="subtitle" i18n>Desarrolla la empatía</p>
    </div>
    <div class="svgs_card">
      <img src="assets/imgs/svgs/brain.svg" alt="Icono plasticidad" i18n-alt srcset="">
      <p class="subtitle" i18n>Aumenta la plasticidad cerebral</p>
    </div>
  </div>
  <div class="mt-5" style="display:flex; justify-content:center; align-items:center; ">
    <a class="button" routerLink="/dosage/benefits" i18n>Quiero saber más</a>
  </div>
</section>
<component-clinical-experience></component-clinical-experience>
<component-testimonials></component-testimonials>
<component-halves-container [style.background-color]="'blue'" imgUrl="assets/imgs/psilocibina.jpg"
  [infoHeaderTemplate]="formulaHeader" [paragraphTemplate]="formulaParagraph" [textOnButton]="learnMoreBtn"
  [btnLink]="'/dosage/formula'">
</component-halves-container>
<section id="protocols">
  <component-splited-header [h2Content]="protocols_header" [paragraphTemplate]="protocols_paragraph">
  </component-splited-header>

  <div class="svgs_container">
    <div class="svgs_card">
      <img src="assets/imgs/svgs/parkinson.svg" alt="Icono parkinson" i18n-alt srcset="">
      <p class="subtitle" i18n>Parkinson</p>
    </div>
    <div class="svgs_card">
      <img src="assets/imgs/svgs/focus.svg" alt="Icono enfoque" i18n-alt srcset="">
      <p class="subtitle" i18n>ADD, ADHD, ATENCION Y CONCENTRACION</p>
    </div>
    <div class="svgs_card">
      <img src="assets/imgs/svgs/self_knowledge.svg" alt="Icono autoconocimiento" i18n-alt srcset="">
      <p class="subtitle" i18n>Autoconocimiento y crecimiento personal</p>
    </div>
    <div class="svgs_card">
      <img src="assets/imgs/svgs/letucce.svg" alt="Icono conexión al gozo" i18n-alt srcset="">
      <p class="subtitle" i18n>Reconexión con el gozo de vivir</p>
    </div>
    <div class="svgs_card">
      <img src="assets/imgs/svgs/addiction.svg" alt="Icono adicciones" i18n-alt srcset="">
      <p class="subtitle" i18n>Adicciones</p>
    </div>
    <div class="svgs_card">
      <img src="assets/imgs/svgs/anxiolytics.svg" alt="Icono ansioliticos" i18n-alt srcset="">
      <p class="subtitle" i18n>Depresión y ansiedad con antidepresivos</p>
    </div>
  </div>
  <div style="display:flex; justify-content:center; align-items:center; ">
    <a class="button" routerLink="/dosage/protocol" i18n>Quiero saber más</a>
  </div>
</section>
<component-start-treatment></component-start-treatment>
<component-footer></component-footer>